import React, { Component } from 'react';

import SearchSimoDevicesForm from 'components/simo/SearchSimoDevicesForm';
import Pagination from 'components/Pagination/Pagination';
import SimoDevicesList from 'components/simo/SimoDevicesList';
import Spinner from 'components/Spinner';

class SearchSimoDevices extends Component {
  state = {
    wasSearch: false,
    loading: false,
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.page !== this.props.page) {
      this.handleSearch();
    }
  }

  handleSearch = (values) => {
    const { page, searchSimoDevices, history } = this.props;

    this.setState({
      loading: true,
    });

    const params = values || this.prevValues || {};
    this.prevValues = params;
    if (page && page !== '1' && values) {
      history.push({
        search: `?page=1`,
      });
      return;
    }
    return searchSimoDevices(page, params)
      .then(() => {
        this.setState({ wasSearch: true });
      })
      .finally(() => this.setState({ loading: false }));
  };

  render() {
    const { simoDevices, pageCount, page } = this.props;
    const { wasSearch, loading } = this.state;

    return (
      <div>
        <h1>Search Simo Devices</h1>
        <SearchSimoDevicesForm onSubmit={this.handleSearch} />
        <br />
        {wasSearch && simoDevices && (
          <SimoDevicesList
            simoDevices={simoDevices}
            viewUrl={(id) => `/simo/devices/${id}/view`}
          />
        )}
        {wasSearch && (
          <Pagination
            count={pageCount}
            current={page}
            url={(pageNum) => `/simo/devices/search?page=${pageNum}`}
          />
        )}
        <Spinner showLoader={loading} />
      </div>
    );
  }
}

export default SearchSimoDevices;
